import { PortOfEntry } from "../models/utilities/port-of-entry";
import { SelectListItem } from "../models/utilities/selectlist-item";
import { IApplicationState } from "../store/IApplicationState";
import { ServiceCenter } from "../models/utilities/service-center";
import { UserNotification } from "../models/utilities/user-notification";

export const getAllServiceCenters = (state: IApplicationState) => 
    state.utility.appServiceCenters;

export const getServiceCenterData = (state: IApplicationState) => {
    return state.utility.appServiceCenters ? state.utility.appServiceCenters : [];
};

export const getServiceCenterTimezone = (state : IApplicationState, toMatch : string) : string  => {
    const allSCs = (state as IApplicationState).utility.appServiceCenters;
    const currentSC = allSCs.find((itm : ServiceCenter) => {
        return itm.name === toMatch;
    });

    return currentSC ? currentSC.timezone : '';
};

export const getPortOfEntrySelectList = (state: IApplicationState) : Array<SelectListItem<string>> => {
    if (!state.utility.portOfEntries) {
        return [];
    }

    return state.utility.portOfEntries.map((port : PortOfEntry) => {
        return new SelectListItem<string>({ id: port.id, name : port.name });
    });
};

export const getNotifications = (state: IApplicationState) : UserNotification[] => {
    if (!state.utility.notifications) {
        return [];
    }

    return state.utility.notifications;
};
